import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivityService } from '../../common/activity.service';

@Component({
  selector: 'activity-question-option-form',
  templateUrl: './activity-question-option-form.component.html',
  styleUrls: ['./activity-question-option-form.component.css', '../../app.component.css'],
  providers: [ActivityService]
})
export class ActivityQuestionOptionFormComponent implements OnInit {

 eventId: any;
 activityId: any;
 activityQuestionId: any;
 activityQuestionOptionId: any;
 activityQuestionOption: any;
 activityQuestionOptionForm: any;
 spinner:boolean = false;

 constructor(private formBuilder: FormBuilder, private activityService: ActivityService){
  this.activityQuestionOptionForm = this.formBuilder.group({
   'id': [''],
   'option': ['', Validators.required],
   'isPrice': ['', Validators.required],
   'price': ['']
  });
  this.activityQuestionOption = this.activityQuestionOptionForm.value;
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveActivityQuestionOption() {
  if(this.activityQuestionOptionForm.valid)
  {
   this.spinner = true;
   var params = this.activityQuestionOptionForm.value;
   params.questionId = this.activityQuestionId;
   this.activityService.saveActivityQuestionOption(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/activity-question-option-form/activity-question-option-form.component.ts